export default "__VITE_ASSET__ye6E7oSz__"